"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const Primary = (0, styled_components_1.default)(typography_1.Button) `
  background-color: ${(props) => props.theme.colors.greyBase};
  color: ${(props) => props.theme.colors.whiteBase};

  &:hover,
  &.hover {
    background-color: ${(props) => props.theme.colors.greyLighten40};
  }

  &:disabled {
    background-color: ${(props) => props.theme.colors.silverLighten40};
    color: ${(props) => props.theme.colors.greyLighten70};
  }
`;
const Secondary = (0, styled_components_1.default)(typography_1.Button) `
  background-color: ${(props) => props.theme.colors.silverLighten70};
  color: ${(props) => props.theme.colors.greyBase};
  border: 1px solid ${(props) => props.theme.colors.silverBase};

  &:hover,
  &.hover {
    color: ${(props) => props.theme.colors.greyLighten40};
    background-color: ${(props) => props.theme.colors.silverBase};
  }

  &:disabled {
    background-color: ${(props) => props.theme.colors.silverLighten40};
    color: ${(props) => props.theme.colors.greyLighten70};
  }
`;
const Tertiary = (0, styled_components_1.default)(typography_1.Button) `
  background-color: ${(props) => props.theme.colors.whiteBase};
  border: 1px solid ${(props) => props.theme.colors.greyBase};
  color: ${(props) => props.theme.colors.greyBase};

  &:hover,
  &.hover {
    background-color: ${(props) => props.theme.colors.silverBase};
  }

  &:disabled {
    background-color: ${(props) => props.theme.colors.silverLighten40};
    color: ${(props) => props.theme.colors.greyLighten70};
    border-color: ${(props) => props.theme.colors.silverLighten40};
  }
`;
const PrimarySmall = (0, styled_components_1.default)(Primary) `
  display: inline-flex;
  font-size: 0.75rem;
  line-height: 120%;
  padding: ${({ theme }) => `${theme.spacings.xxs} ${theme.spacings.xs}`};
  width: unset;
`;
const Link = (0, styled_components_1.default)(typography_1.Button) `
  display: inline-block;
  font-weight: 500;
  padding: 0;
  text-decoration: underline !important;
  width: unset;
  background-color: transparent;

  &:hover {
    color: ${({ theme }) => theme.colors.greyLighten40};
  }

  &:disabled {
    color: ${(props) => props.theme.colors.greyLighten70};
  }
`;
const Transparent = (0, styled_components_1.default)(typography_1.Button) `
  font-weight: 500;
  text-decoration: underline !important;
  background-color: transparent;

  &:hover {
    color: ${({ theme }) => theme.colors.greyLighten40};
  }

  &:disabled {
    color: ${(props) => props.theme.colors.greyLighten70};
  }
`;
const Buttons = {
    primary: Primary,
    secondary: Secondary,
    tertiary: Tertiary,
    primarySmall: PrimarySmall,
    link: Link,
    transparent: Transparent
};
const Button = (0, react_1.forwardRef)(({ variant = "primary", children, isExternal, ...props }, ref) => {
    const ButtonVariant = Buttons[variant];
    return isExternal ? ((0, jsx_runtime_1.jsx)(ButtonVariant, { ...props, as: "a", target: "_blank", rel: "noopener noreferrer", ref: ref, children: children }, void 0)) : ((0, jsx_runtime_1.jsx)(ButtonVariant, { ...props, ref: ref, children: children }, void 0));
});
exports.Button = Button;
//# sourceMappingURL=index.js.map